import { InjectionToken } from '@angular/core';

export class Constants {
  public static AVAILABLE_LANGUAGES = [
    { name: 'Українська', code: 'uk-UA', icon: '/assets/icons/lang/6.svg', isActive: false, isPrimary: false },
    { name: 'Англійська', code: 'en-US', icon: '/assets/icons/lang/1.svg', isActive: true, isPrimary: false },
    { name: 'Польська', code: 'pl-PL', icon: '/assets/icons/lang/2.svg', isActive: false, isPrimary: false },
    { name: 'Німецька', code: 'de-DE', icon: '/assets/icons/lang/3.svg', isActive: false, isPrimary: false },
    { name: 'Іспанська', code: 'es-ES', icon: '/assets/icons/lang/4.svg', isActive: false, isPrimary: false },
    { name: 'Іврит', code: 'iw-IL', icon: '/assets/icons/lang/7.svg', isActive: false, isPrimary: false },
    { name: 'Арабська', code: 'ar-SA', icon: '/assets/icons/lang/8.svg', isActive: false, isPrimary: false },
    { name: 'російська', code: 'ru-RU', icon: '/assets/icons/lang/5.svg', isActive: false, isPrimary: false }
  ];

  public static DEFAULT_LANGUAGES: Language = {
    name: 'Англійська',
    code: 'en-US',
    icon: '/assets/icons/lang/1.svg',
    isActive: true,
    isPrimary: false
  };
}

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});

export interface Language {
  name: string;
  code: string;
  icon: string;
  isActive: boolean;
  isPrimary: boolean;
}

export const ICONS = [
  { name: 'dubbing-union', url: '../assets/icons/dubbing/union.svg' },
  { name: 'dubbing-add', url: '../assets/icons/dubbing/add.svg' },
  { name: 'dubbing-transcribe', url: '../assets/icons/dubbing/transcribe.svg' },
  { name: 'dubbing-translate-off', url: '../assets/icons/dubbing/translate-off.svg' },
  { name: 'dubbing-player-speed', url: '../assets/icons/dubbing/player-speed.svg' },
  { name: 'dubbing-eye-off', url: '../assets/icons/dubbing/eye-off.svg' },
  { name: 'voicing-eleven-labs', url: '../assets/icons/voicing/eleven-labs.svg' },
  { name: 'voicing-open-ai', url: '../assets/icons/voicing/open-ai.svg' },
  { name: 'voicing-settings', url: '../assets/icons/voicing/settings.svg' },
  { name: 'voicing-voice-1', url: '../assets/icons/voicing/icons/voice-1.svg' },
  { name: 'voicing-voice-2', url: '../assets/icons/voicing/icons/voice-2.svg' },
  { name: 'voicing-voice-3', url: '../assets/icons/voicing/icons/voice-3.svg' },
  { name: 'voicing-voice-4', url: '../assets/icons/voicing/icons/voice-4.svg' },
  { name: 'voicing-voice-5', url: '../assets/icons/voicing/icons/voice-5.svg' },
  { name: 'voicing-voice-6', url: '../assets/icons/voicing/icons/voice-6.svg' },
  { name: 'voicing-voice-7', url: '../assets/icons/voicing/icons/voice-7.svg' },
  { name: 'voicing-voice-8', url: '../assets/icons/voicing/icons/voice-8.svg' },
  { name: 'voicing-voice-9', url: '../assets/icons/voicing/icons/voice-9.svg' },
  { name: 'voicing-voice-10', url: '../assets/icons/voicing/icons/voice-10.svg' },
  { name: 'smm-file', url: '../assets/file-icons/file.svg' },
  { name: 'smm-doc', url: '../assets/file-icons/doc.svg' },
  { name: 'smm-image', url: '../assets/file-icons/image.svg' },
  { name: 'smm-pdf', url: '../assets/file-icons/pdf.svg' },
  { name: 'smm-ppt', url: '../assets/file-icons/ppt.svg' },
  { name: 'smm-xls', url: '../assets/file-icons/xls.svg' },
  { name: 'smm-zip', url: '../assets/file-icons/zip.svg' },
  { name: 'smm-download', url: '../assets/file-icons/download-file.svg' },
  { name: 'smm-upload', url: '../assets/file-icons/upload-file.svg' },
  { name: 'smm-audio', url: '../assets/file-icons/audio.svg' },
  { name: 'smm-video', url: '../assets/file-icons/video.svg' },
  { name: 'smm-file-error', url: '../assets/file-icons/file-error.svg' }
];

